import { storage } from '@/utils';
import router from '@/router';

export default {
  namespaced: true, // 命名模块
  state: () => ({
    userInfo: {},
  }),
  mutations: {
    SET_USER_INFO(state, info) {
      state.userInfo = info;
    },
  },
  // 处理异步操作
  actions: {
    loginApi({ commit }, result) {
      commit('SET_USER_INFO', result);
    },
    // 退出api
    logoutApi({ commit }) {
      commit('SET_USER_INFO', {});
      storage.clear();
      window.sessionStorage.clear();
      router.push('/login');
    },
  },
};
